import Translation from 'app/shared/components/Translation/Translation';

const DefaultLoginButtonText = () => {
  return <Translation id="auth.loginForm.loginButton" defaultMessage="Login" />;
};

export default DefaultLoginButtonText;
